module.exports = __webpack_public_path__ + "static/media/icon-company.820771b2.svg";